// extracted by mini-css-extract-plugin
export default {"orders":"Orders_orders__0HnqI","order":"Orders_order__lPR5u","items":"Orders_items__JKjzO","item":"Orders_item__BfrmL"};